import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot } from '@angular/router';

import { isComponentMapKey, SidePanelService } from './side-panel.service';

@Injectable({
  providedIn: 'root',
})
export class SidePanelRouteGuard {
  #router = inject(Router);
  #sidePanelService = inject(SidePanelService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const routeConfig = route.routeConfig;

    // A route whose path is not a panel key has no panel to open, so it renders as itself
    // rather than having its outlet segment stripped.
    if (!routeConfig || !isComponentMapKey(routeConfig.path)) {
      return true;
    }

    this.#sidePanelService.setActiveComponent(routeConfig.path);

    return this.#cleanupUrl(state.url, routeConfig);
  }

  #cleanupUrl(url: string, { path, outlet }: Route) {
    const strippedUrl = url.replace(`(${outlet}:${path})`, '');

    return this.#router.parseUrl(strippedUrl);
  }
}
